<div
  class="card-basic {{ cardClass() }}"
  [ngClass]="{ 'has-background': hasBackground(), 'h-100': height100(), 'no-box-shadow': noBoxShadow() }"
>
  @if (hasBackground()) {
    <div class="card-background"></div>
  }
  <ng-content />
  @if (optionalLastChildClass()) {
    <div class="{{ optionalLastChildClass() }}"></div>
  }
</div>
